<div class="admin-job-definition">
  <h2>Job definition</h2>
  <input type="text" class="form-control" [(ngModel)]="jobName" placeholder="Enter job name">
  <button type="button" class="btn btn-primary me-1 mt-1" (click)="getJobDefinition(jobName)">Refresh</button>
  @if (jobName && jobDefinition) {
    <div>
      Job definition: {{ jobDefinition }}<br>
      <button type="button" class="btn btn-primary me-1" (click)="changeDefinition(jobName)">change definition
      </button>
    </div>
  }
</div>
